import type { FilesProxySchemaWithId } from '@iconik-io/iconik-api/src/services/files';

import { sortByMediaTypeAndDate } from './sort_proxies_by_media_type';

export function findClosedProxies(proxies: FilesProxySchemaWithId[]) {
  const closedProxies = proxies.filter((proxy) => proxy.status === 'CLOSED');
  closedProxies.sort(sortByMediaTypeAndDate);
  return closedProxies;
}

export function findLatestClosedProxy(proxies: FilesProxySchemaWithId[]) {
  const closedProxies = findClosedProxies(proxies);
  return closedProxies[0];
}
